'use client';

import { useCallback } from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';

export function useParamsUpdater(config?: { isNative: boolean }) {
  const { isNative } = config || {};

  const router = useRouter();

  const pathname = usePathname();

  const searchParams = useSearchParams();

  const onChange = useCallback(
    (
      newParams: {
        [key: string]:
          | string
          | number
          | Array<string | number>
          | null
          | undefined;
      },
      newPathname?: string
    ) => {
      const params = new URLSearchParams(searchParams?.toString());

      Object.entries(newParams).forEach(([key, value]) => {
        if (!value) {
          return params.delete(key);
        }

        if (Array.isArray(value)) {
          params.delete(key);

          value.forEach((item) => {
            params.append(key, String(item));
          });

          return;
        }

        params.set(key, String(value));
      });

      const stringifiedParams = params.toString();

      const pathToUsage = newPathname || pathname;

      const newPath = pathToUsage + `?` + stringifiedParams;

      if (isNative) {
        window.history.replaceState(null, '', newPath);
      } else {
        router.push(newPath, { scroll: false });
      }
    },
    [router, pathname, searchParams, isNative]
  );

  return { onChange: onChange, searchParams: searchParams };
}

export default useParamsUpdater;
